import { SparePart } from './../models/sparepart';
import { SparepartService } from './../services/sparepart.service';
import { MessageService } from './../services/message.service';
import { Message } from './../common/message';

import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material';
import { ConfirmDeleteDialogComponent } from '../dialog/confirm-delete-dialog/confirm-delete-dialog.component';

let ELEMENT_DATA = [];
@Component({
  selector: 'app-spareparts',
  templateUrl: './spareparts.component.html',
  styleUrls: ['./spareparts.component.scss']
})
export class SparepartsComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = ['SN', 'name', 'code','minQty','maxQty','desc', 'actions'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  resource: any;

  constructor(private dialog: MatDialog, private service: SparepartService, private formBuilder: FormBuilder, private msg: MessageService) { }

  ngOnInit() {
    this.resource = new SparePart();
    this.setMessageForm();
    this.getResources();
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      code: ['', Validators.required],
      minQty: ['', Validators.required],
      maxQty: ['', Validators.required],
      desc: ['', Validators.required]
    });
  }

  getResources() {
    ELEMENT_DATA = [];
    this.service.getAll()
      .subscribe(result => {
        ELEMENT_DATA = ELEMENT_DATA.concat(result);
        this.updateDataSource();
      })
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.resource = new SparePart();
    this.isFormDisplay = true;
  }

  displayTable() {
    this.isFormDisplay = false;
    this.resetForm();
  }

  onSave(name: HTMLDataElement, code: HTMLDataElement, desc: HTMLDataElement,minQty : HTMLDataElement, maxQty : HTMLDataElement ) {

    this.submitted = true;

    if (this.form.controls.name.errors) {
      return;
    }

    if (this.resource.id) {
      this.updateElement(name, code, desc, minQty, maxQty);
    } else {
      this.addElement(name, code, desc, minQty, maxQty);
    }

  }

  resetForm(ret?: boolean) {
    this.form.reset();
    this.submitted = false;
    if (ret) this.isFormDisplay = false;
  }



  addElement(name, code, desc, minQty, maxQty) {
    this.resource.setName(name.value);
    this.resource.setCode(code.value);
    
    this.resource.setMinQty(minQty.value);
    this.resource.setMaxQty(maxQty.value);
    
    this.resource.setDesc(desc.value);

    this.service.create(this.resource)
      .subscribe(result => {
        this.msg.alert(Message.SAVE);
        ELEMENT_DATA.push(result);
        this.updateDataSource();
        this.resource = new SparePart();
        this.resetForm();
      }, (err : any) => {
        if(err.status == 422){
          this.msg.alert(Message.ADDED_BEFORE_PLAESE_CHECK);
        }
      })
  }

  updateElement(name, code, desc, minQty, maxQty) {
    this.resource.setName(name.value);
    this.resource.setCode(code.value);

    this.resource.setMinQty(minQty.value);
    this.resource.setMaxQty(maxQty.value);

    this.resource.setDesc(desc.value);

    this.service.update(this.resource)
      .subscribe(result => {
        this.msg.alert(Message.UPDATE);
        ELEMENT_DATA.forEach((elem, index) => {
          if (elem.id === this.resource.id) {
            ELEMENT_DATA.splice(index, 1, result);
            return;
          }
        })

        this.updateDataSource();
        this.resource = new SparePart();
        this.resetForm(true);
      }, (err : any) => {
        if(err.status == 422){
          this.msg.alert(Message.ADDED_BEFORE_PLAESE_CHECK);
        }
      })
  }

  editElement(ele) {

    this.isFormDisplay = true;
    this.isAddNew = false;
    this.resource = ele;
    this.resource = new SparePart();

    this.resource.setId(ele.id);
    this.resource.setName(ele.name);
    this.resource.setCode(ele.code);

    this.resource.setMinQty(ele.value);
    this.resource.setMaxQty(ele.value);

    this.resource.setDesc(ele.desc);

    this.form.controls.name.setValue(ele.name);
    this.form.controls.code.setValue(ele.code);

    this.form.controls.minQty.setValue(ele.minQty);
    this.form.controls.maxQty.setValue(ele.maxQty);

    this.form.controls.desc.setValue(ele.desc);

  }

  deleteElement(ele) {
    this.dialog.open(ConfirmDeleteDialogComponent)
      .afterClosed()
      .subscribe(result => {
        if (result === "true") {
          this.service.delete(ele.id)
            .subscribe(result => {
              this.msg.alert(Message.DELETE);
              let index = ELEMENT_DATA.indexOf(ele);
              ELEMENT_DATA.splice(index, 1);
              this.updateDataSource();
            })
        } else {
          return;
        }
      });

  }

}
